import type { PaymentModuleId } from '@foundation/apis/payments';
import { SupportedLanguage } from '@foundation/localization';

import { execGet, execPost } from '@/services/utils/RequestUtils';

import { FlutterwaveUrlApiResponse } from '../schemas';

export async function getCardUrl(
  paymentIntentId: string,
  accessToken: string,
  paymentInstrumentId?: string,
  locale = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> {
  const searchParams = new URLSearchParams({
    tc: telemetryConsent.toString(),
    locale,
  });

  if (paymentInstrumentId !== undefined) {
    searchParams.append('paymentDataId', paymentInstrumentId.toString());
  }

  const response = await execGet<FlutterwaveUrlApiResponse>(
    `paymentintent/${paymentIntentId}/flutterwave/url?${searchParams.toString()}`,
    accessToken,
  );

  return response.redirectUrl;
}

export async function getManageCardUrl(
  legalEntityNumber: number,
  customerNumber: string,
  accessToken: string,
  moduleId: PaymentModuleId,
  locale = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> {
  const response = await execPost<FlutterwaveUrlApiResponse>(
    `paymentinstruments`,
    {
      legalEntityNumber: legalEntityNumber,
      customerNumber: customerNumber,
      paymentDataTypeId: moduleId,
      locale: locale,
      tc: telemetryConsent,
    },
    accessToken,
  );

  return response.redirectUrl;
}
